"use strict";

define('rs/form/boolean.dynamicproperty',['evisions/dynamicproperty'], function (DynamicProperty) {
  var BooleanDynamicProperty = DynamicProperty.extend({
    fetch: function fetch() {
      var deps = this.getDependencies(),
        key = this.getKey();
      return _.some(deps, function (dep) {
        return dep.get(key);
      });
    },
    setup: function setup() {
      var dependencies = this.getDependencies(),
        len = dependencies.length,
        changeFn = this.dependencyDidChange.proxy(this),
        key = this.getKey(),
        oneIsValid = false,
        i = 0;
      if (len === 0) {
        oneIsValid = true;
      }
      for (i = 0; i < len; ++i) {
        if (oneIsValid || dependencies[i].get(key)) {
          oneIsValid = true;
        }
        this.listenTo(dependencies[i], 'change:' + key, changeFn);
      }
      if (oneIsValid) {
        this.setValue(true);
      } else {
        this.setValue(false);
      }
    },
    dependencyDidChange: function dependencyDidChange() {
      this.update();
    }
  });
  return BooleanDynamicProperty;
});

